/*
 * @Author: 朱占为
 * @LastEditors: 李青花
 * @description: 接口配置文件
 * @Date: 2021-07-20 10:48:41
 */

export default {
  TEST: '/test', // 测试接口
  HOME_SEARCH_APP: '/MyApp/searchApp', // 获取app接口
  HOME_GET_MY_NOTICE: '/MyNotice/getMyNotices', // 获取notices
  HOME_LATEST_ORDER: '/MyOrder/listOrder', // 获取Latest Orders
  ACTIVE_LATEST_ORDER: '/MyOrder/homeOrder', //active优先展示
  HOME_GET_LIST: '/MyApp/getList', // 获取your apps
  ORDER_POST_REVIEW: '/MyOrder/getReview', //获取评论
  POST_ADDAPP:'/MyApp/addApp',// 添加app
  GET_SINGLE_OPTINFO:'/MyOrderOpt/getSingleOptInfo',
  POST_START_ORDER:'/MyOrder/startOrder', //开始订单
  GET_ORDER_DETAIL:'/MyOrder/getOrderDetail', //订单详情
  GET_RECOMMENDWORDS:'/MyOrder/getRecommendWords', //获取关键词列表
  MY_GREVIEW_ORDER:'/MyGReviewOrder/getOrderDetail',
  MY_KEYWORDS_ORDER:'/MyKeywordAcqu/getOrderDetail',//关键词订单详情
  GET_APP_LIST:'MyApp/getList', //获取app
  POST_CANCELORDER:'MyOrder/cancelOrder',//订单取消
  POST_DELETEORDER:'MyOrder/deleteOrder',
  // 地区 Region
  POST_COUNTRY_LIST: '/Region/list', // 获取国家
  POST_CONTINUE_ORDER:'/MyOrder/continueOrder',//继续订单
  POST_PAUSE_ORDER:'/MyOrder/pauseOrder',//暂停订单


  GET_USER_PREFER:'/User/prefer',//设置个人偏好
  MINE_GET_INFO:'/User/GetMineInfo',//获取个人信息
  GET_USER_ACTIVE:'User/getUserActiveOpt',//获取用户状态
  CLOSE_NEW_GUIDE:'/User/closeNewGuide', //关闭home页的用户引导
  
  MINE_UPDATE_REGION:'/User/updateRegion',//获取更新国家接口
  MINE_MEMBER_INFO:'/MyMember/getMemberGradeByUserId',//获取会员等级
  MINE_UPDATE_PASSWORD:'/User/updatePassword',//获取更新密码接口
  MINE_TRANSACTIONS_DATA:'/Balance/getTransactionLog',//获取transaction模块数据
  MINE_REFER_LINK:'/MyReferLink/getMyReferLink',//获取referral链接
  MINE_MYREFER_TABLE:'/MyRefer/getMyCommission',//获取referral模块的表格数据
  MINE__MY_LOG_DATA:'/MyRefer/getMyLog',//获取referral模块的表格数据
  MINE_REFERRAL_ACTIVITY:'/MyActivity/getReferralActivity',//获取referral活动信息
  MINE_ALL_MEMBER_INFO:'/MyMember/getOpenedMemberGradesByConsumption',//获取所有会员等级信息
  MINE_TOTAL_COST:'/MyMember/getTotalCost',//获取总共的消耗
  MINE_CONTACT_MESSAGE:'/Contact/submitMsg',//发送contact信息
  MINE_SET_STAR:'/MyApp/setTop',//设置App收藏/置顶
  MINE_DELETE_KEYWORD:'/MyKeyword/delete',//删除关键字
  MINE_DELETE_APP:'/MyApp/delete',//删除app
  MINE_RECOMMENDDATION_KEYWORD:'/MyKeyword/showSuggestForApp',//系统推荐关键字
  MINE_COUPON_LIST:'MyActivity/hadNewPromo',//获取优惠券列表
  MINE_RECHARGE_SUCCESS_CODE:'/MyActivity/stepActivityPromo',//获取充值成功跳转后的优惠券

  GET_WORD_RANK:'MyKeyword/getWordRank', // rank信息
  GET_RANK_HISTORY:'MyKeyword/rankHistory',
  GET_KEYWORD_HISTORY:'myKeyword/getKeywordHistory',
  GET_REVIEW:'MyOrder/getReview', //获取草稿订单的评论
  POST_LASTCONTACT: 'MyPurpose/getLastContact', //获取上一次内容
  POST_ACQU_LASTCONTACT: 'MyKeywordAcqu/getLastContact', //获取上一次内容
  POST_WORD_RANK_REFRESH:'MyKeyword/requestWordRankRefresh', //刷新rank
  POST_LIST_WORDS:'MyKeyword/listWords', // 查询关键词
  POST_LIST_WORDS_AND_RANK:'MyKeyword/listWordsAndRankSort', // 查询关键词
  POST_ADD_KEYWORD:'MyKeyword/addKeyword', // 添加关键词
  POST_GREVIEW_ADD_ORDER:'MyGReviewOrder/addOrder', // 保存订单
  POST_ADD_ORDER:'MyOrder/addOrder',//保存订单
  POST_RECOMMENDED_REVIEWS:'MyReviews/getRecommendedReviews',

  POST_PAYTYPE:'MyPayType/getOpenedPayType' , //获取支付方式
  POST_PAYRYPE_INFO:'/MyActivity/getStepActivity', //获取支付提示信息
  POST_PROMO_CODE:'MyPromoCode/checkPromoCode',//使用优惠码


  POST_PAYTYPE_ID:'/Balance/paypalClientId', //获取客户端id
  POST_PAYTYPE_ORDER_STATUS:'Balance/isPaySucceed', //获取订单状态
  POST_PAYTYPE_ORDER_GETBALANCE:'/Balance/getBalance', //获取订单状态
  POST_USER_EMAIL:'User/reSendMail' ,//重新发送邮箱
  CREATE_PAY_ORDER:'Balance/createOrder', //创建支付订单
  //发起支付
  PAY_ORDER_PAYPAL:'Balance/payOrderByPayPal', //Paypal
  PAY_ORDER_PACYPAY:'Balance/payOrderByPacypayDirect', //Pacypay
  PAY_ORDER_WANPAY:'Balance/payOrderByWanPay', //wanpay
  PAY_ORDER_STRIPEPAY:'Balance/payOrderByStripeAgent', //Stripe
  PAY_ORDER_PASSPAY:'Balance/payOrderByPassPay', //PassPay
  PAY_ORDER_ALLPAY:'Balance/payOrderByAllPay', //GoAllPay
  PAY_ORDER_GLOCASHPAY:'Balance/payOrderByGloCash', //Glocash
  PAY_ORDER_UNIQUEPAY:'Balance/payOrderByPayssion',//统一支付
  PAY_ORDER_PAYOP:'Balance/payOrderByPayOp',//payop
  PAY_ORDER_TEST:'Balance/payOrderByTest',//测试支付   勿删
  PAY_ORDER_AIRWALLEX:'Balance/payOrderByAirwallex',//airwallex支付
  PAY_ORDER_PAYOP_BITCOIN:'Balance/payOrderByPayOpWithBitcoin',//payop-bitcoin支付
  PAY_ORDER_PAYOP_BITCOINCASH:'Balance/payOrderByPayOpWithBitcoinCash',//PayOp-Bitcoin Cash支付
  PAY_ORDER_PAYOP_LITECOIN:'Balance/payOrderByPayOpWithLitecoin',//PayOp-Litecoin支付
  PAY_ORDER_PAYOP_ETHEREUM:'Balance/payOrderByPayOpWithEthereum',//PayOp-Ethereum支付
  PAY_ORDER_EPAY_USDT:'Balance/initEPayWithUSDTData',//EPAY_USDT支付
  PAY_ORDER_EPAY_USDTRESULT:'Balance/confirmPayOrderByEPayWithUSDT',//EPAY_USDT支付结果页
  PAY_ORDER_COIN_BASE:'Balance/payOrderByCoinBase',//COINBASE支付
  PAY_ORDER_TRIPLE_A:'Balance/payOrderByTripeA', // triple_a 支付
  PAY_ORDER_XAN_PAY:'Balance/payOrderByXanPay', // xanpay 支付
  PAY_ORDER_PAYONEER:'Balance/payOrderByPayonner', // payoneer 支付
  PAY_ORDER_CRYPTOMUS:'Balance/payOrderByCryptomus', // payoneer 支付
  PAY_ORDER_BINANCE:'Balance/payOrderByBinance', // binance 支付
  POST_SET_CONTACT:'User/setContact', //设置联系方式
  POST_CREATE_PAY_ORDER:'/Balance/payOrderByPayPalId',
  GET_ALL_SERVICES:'Services/getAllServices',
  GET_BLOGS:'MyIndex/getBlogs',

  GET_RATING_INFO:'MyApp/getAppRatingsReport',//获取app的rating信息
  GET_KEYWORDS_ORDER:'/MyKeywordAcqu/getOrders', //获取关键词覆盖订单列表
  GET_ASO_ORDER:'/MyAsoService/getMyAsoService',//获取aso订单
  GET_GUARANTEED_RANKING:'/MyPurpose/getPurpose',//获取关键词保排名订单
  GET_HAS_UNREAD:'MyPushMsg/hasUnread',
  GET_READ_PUSH_MSG:'MyPushMsg/readPushMsg',
  GET_PUSH_MSG:'MyPushMsg/getPushMsgs',
  GET_RANKING_INFO:'MyApp/getAppRankReport',//获取app的ranking信息
  GET_KEYWORD_INFO:'MyKeyword/listWords',//获取app的keyword信息
  GET_REVIEW_INFO:'MyApp/getAppReviews',//获取app的review
  GET_VALIDATE_INFO:'MyOrder/checkLReviewUrl',//校验链接


  // 智能投放部分
  GET_COMPETE_APPS:'MyOrder/getCompeteApps', //获取竞品app
  GET_COMPETE_WORDS:'MyOrder/getCompeteWords', //根据竞品app获取竞品关键词
  GET_SMART_COMPETE_WORDS:'MyOrder/getSmartServiceRecommendWords', //根据竞品app获取竞品关键词
  GET_SMART_CTRL:'MyServiceCtrl/getSmartCtrl',  //获取智能投放数量策略设置的数据
  
  //support 客户经理联系方式
  GET_MANAGER_CONTACT:'User/getUserCard',
  GET_CONSUMPTION_DATA:'Balance/getConsumptionData',//获取消耗统计数据
  POST_SUNSCRIBE:'User/consumptionSubscribe',//订阅
  POST_UNSUNSCRIBE:'User/cancelSubscribe',//退订
  
  CHECK_IOS_REVIEW:'/MyOrder/checkIosReview',//敏感词校验

  GET_RESELLER_LEVEL:'/MyMember/getResellerMember',//获取reseller的level列表
  CANCEL_RESELLER_FORM:'/MyResellerApplication/cancelLastApplication',//撤销分销商申请
  CREATE_RESELLER_FORM:'/MyResellerApplication/createResellerApplication',//提交分销商申请
  GET_LAST_RESELLER_APPlication:'/MyResellerApplication/getLastApplication',//获取上一次申请信息
  GET_RESELLER_STATE:'/MyResellerApplication/getLastApplicationState',//获取申请状态


  EVENT_TRACK:'/Tracking/eventTrack',//埋点

  //api订单数据
  GET_API_ORDERS:'/MyApiService/queryOrderByUid',
  GET_API_SERVICES:'/MyApiService/getApiService',
  GET_API_CALLNUMBERS:'/MyApiService/queryRemainingNumber',


  // 优惠券接口
  GET_PROMO_CODE: '/MyPromoCode/listPromoCode', //获取优惠券
  GET_PROMO_CODE_S: '/MyPromoCode/queryAvailablePromoCode', //获取优惠券


  //诊断信息
  GET_APP_BASE_DATA: '/MyApp/getAppDiagnosis',
  GET_APP_SHOP_DATA: '/MyApp/getAppShopDiagnosis',
  GET_APP_WORD_DATA: '/MyApp/getAppWordDiagnosis',

  //获取关键词覆盖订单弹窗信息
  GET_COVER_PACKAGE_DIALOG: '/MyKeywordAcqu/getOrderAck',

  //获取分类支付信息
  GET_CLASS_PAY_TYPE: '/MyPayType/getClassify',

  // 新获取嵌入式支付信息
  GET_EMBED_PAY_ORDER_BY_AIRWALLEX: '/Balance/payOrderByAirwallex4Sdk',

};

